'use client';

import { usePathname } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import styles from './LocaleSwitcher.module.scss';

export default function LocaleSwitcher() {
	const t = useTranslations('LocaleSwitcher');
	const locale = useLocale();
	const pathname = usePathname();

	if (pathname === '/' || pathname.startsWith('/en') || pathname.startsWith('/postcode')) {
		let target_path: string;

		if (locale === 'nl') {
			if (pathname.startsWith('/nl')) {
				target_path = pathname.replace('/nl/', '/en/');
			} else {
				target_path = `/en/${pathname}`;
			}

			return (
				<a className={styles.localeSwitcher} href={target_path}>
					{t('en')}
				</a>
			);
		}

		target_path = pathname.replace('/en', '/nl');

		return (
			<a className={styles.localeSwitcher} href={target_path}>
				{t('nl')}
			</a>
		);
	} else {
		return null;
	}
}
